export default "__VITE_ASSET__4e740f87__"